/* loaded by smart-asset */
export default require("./microphone~pFtSEjGu.png")